import React, { useEffect, useState } from "react";
import { showToast, autoLogout } from "../common/ToastProvider";
import "./VotingPage.css";

function VotingPage() {
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [session, setSession] = useState(null);

  const [symbolCode, setSymbolCode] = useState("");
  const [codeAvailable, setCodeAvailable] = useState(null);
  const [otpEnabled, setOtpEnabled] = useState(false);

  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpTimer, setOtpTimer] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  // 🔥 जब भी नया OTP generate होगा, toast में show होगा

  useEffect(() => {
    if (generatedOtp) {
      showToast(
        <div className="otp-toast">OTP is: {generatedOtp}</div>,
        "success",
        60000,
         "top-center" 
      );
    }
  }, [generatedOtp]);
  // Check session on page load
useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/checkSession.php`, {
    credentials: "include",
  })
    .then((res) => res.json())
    .then((data) => {
      if (!data.loggedIn) {
        window.location.href = "/";
      } else if (data.alreadyVoted) {
        // Agar pehle vote kar chuka hai
        showToast("You have already voted!", "warn");
        setTimeout(() => {
          window.location.href = "/";
        }, 5000); // 2 sec baad redirect
      } else {
        setSession(data);
        loadCandidates();
      }
    })
    .catch((err) => {
      console.error("Error checking session", err);
      showToast("Error checking session", "error");
      window.location.href = "/";
    });
}, []);


  const loadCandidates = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/getCandidates.php`
      );
      const data = await res.json();
      setCandidates(data);
    } catch (err) {
      console.error("Error fetching candidates", err);
      showToast("Error fetching candidates", "error");
    }
  };

  const handleLogout = async () => {
    await fetch(`${process.env.REACT_APP_API_URL}/logout.php`, {
      credentials: "include",
    });
    window.location.href = "/";
  };

  const getOtp = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/generateOtp.php`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      const data = await res.json();
      if (data.success) {
        setGeneratedOtp(data.otp);
        setOtpVerified(false);

        // showToast("OTP generated successfully!", "info");

        setOtpTimer(60);
        const countdown = setInterval(() => {
          setOtpTimer((prev) => {
            if (prev === 1) {
              clearInterval(countdown);
              setGeneratedOtp(null);
              showToast("OTP expired, request again", "warn");
              return null;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        showToast(data.message || "Failed to generate OTP", "error");
      }
    } catch (err) {
      showToast("Error generating OTP", "error");
    }
  };

  const verifyOtp = async () => {
    try {
      const formData = new FormData();
      formData.append("otp", otp);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/verifyOtp.php`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );
      const data = await res.json();
      if (data.success) {
        setOtpVerified(true);
        showToast("OTP verified, you can now cast your vote", "success");
      } else {
        showToast(data.message, "error");
      }
    } catch (err) {
      showToast("Error verifying OTP", "error");
    }
  };

  const handleVote = async () => {
    if (!otpVerified) {
      showToast("Please verify OTP before voting", "warn");
      return;
    }
    if (!selectedCandidate) {
      showToast("Please select a candidate", "warn");
      return;
    }
    if (!symbolCode || !codeAvailable) {
      showToast("Please enter and check a valid symbol code", "warn");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("candidate_id", selectedCandidate);
      formData.append("symbol_code", symbolCode);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/castVote.php`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      const data = await res.json();

      if (data.success) {
        setShowSuccessPopup(true); // ✅ popup dikhao
        setTimeout(() => {
          setShowSuccessPopup(false);
          handleLogout(); // direct logout call
        }, 3000); // 3 sec baad band aur redirect
      } else {
        showToast(data.message || "Error casting vote", "error");
      }
    } catch (err) {
      showToast("Error connecting to server", "error");
    }
  };

  // Symbol code validation (only alphanumeric)
  const handleSymbolChange = (e) => {
    const value = e.target.value;
    const regex = /^[A-Za-z0-9]*$/;
    if (regex.test(value)) {
      setSymbolCode(value);
    }
  };

  const checkSymbol = async () => {
    if (!symbolCode) {
      showToast("Please enter a symbol code", "warn");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("symbol_code", symbolCode);

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/checkSymbol.php`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );
      const data = await res.json();
      setCodeAvailable(data.available);
      if (data.available) {
        setOtpEnabled(true);
        showToast("Symbol Code is available!", "success");
      } else {
        setOtpEnabled(false);
        showToast("Symbol Code already taken", "error");
      }
    } catch (err) {
      showToast("Error checking symbol code", "error");
    }
  };

  return (
    <div className="voting-container text-center">
      {/* Header */}
      {/* <div className="header-box">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div> */}

      {/* Voting Box */}
      <div className="voting-box">
        <div className="voting-upper">
          {/* Title */}
          <div className="title-row">
            <button className="title-btn">
              SELECT ANYONE CANDIDATE
              <div>
                <img src="/images/speaker.webp" alt="Speaker" width="30" />
              </div>
            </button>
          </div>

          {/* Reference and Constituency */}
          <div className="ref-const-row">
            <label>
              VOTER REFERENCE ID
              <div>
                <img src="/images/speaker.webp" alt="Speaker" width="30" />
              </div>
            </label>
            <input
              type="text"
              readOnly
              value={session?.mobile || "9876543210"}
            />
          </div>
          <div className="ref-const-row" style={{ gap: "35px" }}>
            <label>
              CONSTITUENCY NO.
              <div>
                <img src="/images/speaker.webp" alt="Speaker" width="30" />
              </div>
            </label>
            <input
              type="text"
              readOnly
              value="XXXXXXXXXX"
              style={{ background: "white", color: "#000" }}
            />
          </div>

          {/* Candidates Table */}
          <div className="candidates-table">
            <div className="table-header-row">
              <div>SERIAL NO.</div>
              <div>CANDIDATE PHOTO</div>
              <div>CANDIDATE NAME</div>
              <div>CANDIDATE SYMBOL</div>
              <div>SELECT ANY ONE</div>
            </div>

            {candidates.length === 0 && (
              <div className="loading-msg">Loading candidates...</div>
            )}

            {candidates.map((c, idx) => (
              <div
                className={`table-row ${
                  selectedCandidate === c.id ? "selected" : ""
                }`}
                key={c.id}
              >
                <div className="candidate-serial">{idx + 1}</div>
                <div className="candidate-photo">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${c.candidate_photo}`}
                    alt={c.name}
                  />
                </div>
                <div className="candidate-name">
                  {c.name.toUpperCase()}{" "}
                  <div>
                    <img src="/images/speaker.webp" alt="Speaker" width="30" />
                  </div>
                </div>
                <div className="candidate-symbol">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${c.party_photo}`}
                    alt="symbol"
                  />
                </div>
                <div className="candidate-select" style={{paddingTop:"6px"}}>
                  <input
                    type="radio"
                    name="candidate"
                    checked={selectedCandidate === c.id}
                    onChange={() => setSelectedCandidate(c.id)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Symbol Code Section */}
        <div className="symbol-code-section">
          {/* Left Keyboard Icon */}
          <div className="symbol-part">
            <img
              src="/images/keyboard.jpg"
              alt="Keyboard"
              className="keyboard-icon"
            />
          </div>

          {/* Input + Pen + Label */}
          <div className="symbol-part">
            <div className="symbol-code-input">
              <img src="/images/pen.jpg" alt="Pen" className="pen-icon" />
              <input
                type="text"
                value={symbolCode}
                onChange={handleSymbolChange}
                maxLength={10}
              />
              {!symbolCode && (
                <span className="custom-placeholder">
                  TYPE HERE ANY THINGS & CLICK ON CHECK
                </span>
              )}
              <span className="symbol-label">
                SYMBOL CODE {"  "}
                <img src="/images/speaker.webp" alt="Speaker" width="30" />
              </span>
            </div>
            <span className="part-number">1</span>
          </div>

          {/* Check Button */}
          <div className="symbol-part">
            <div className="check-box">
              {/* <img src="/images/arrow.jpg" alt="Pen" className="arrow-icon" /> */}
              <button className="image-button" style={{marginTop:"10px"}}  onClick={checkSymbol}>
                <img src="/images/check.jpg" alt="Speaker" width="70" />
              </button>
            </div>
            <img src="/images/speaker.webp" alt="Speaker" width="30" />
            <span className="part-number">2</span>
          </div>

          {/* Availability Section */}
          <div className="symbol-part" style={{ marginTop: "16px" }}>
            <div className="availability-section">
              <div
                className={`availability-indicator ${
                  codeAvailable === true
                    ? "yes"
                    : codeAvailable === false
                    ? "no"
                    : ""
                }`}
              ></div>
              <span className="availability-text">
                {codeAvailable === null
                  ? "AVAILABILITY"
                  : codeAvailable
                  ? "AVAILABLE"
                  : "NOT AVAILABLE"}
              </span>
            </div>
            <span className="part-number">3</span>
          </div>
        </div>

        {/* OTP Section */}
        {/* OTP Section जैसा इमेज में है */}
        {!otpVerified && (
          <div className="otp-container">
            {/* 1. GET OTP Button */}
            <div className="otp-step">
              {/* <img
                src="/images/arrow.jpg"
                alt="Pen"
                className="arrow-icon"
                style={{ marginRight: "25px" }}
              /> */}
              <div className="element-with-speaker1">
                <button
                className="image-button"
                  onClick={getOtp}
                  disabled={!otpEnabled}
                  style={{paddingTop:"12px"}}
                >
                   <img src="/images/otp.jpg" alt="otp" width="100" />
                </button>
                <img src="/images/speaker.webp" alt="Speaker" width="20" />
              </div>
            </div>

            {/* 2. ENTER OTP Input */}
            <div className="otp-step">
              <img src="/images/pen.jpg" alt="Pen" className="pen-icon mt-2" />
              <div className="element-with-speaker">
                <input
                  type="text"
                  className="otp-input"
                  inputMode="numeric"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  maxLength="6"
                />
              </div>
              <label className="input-label">
                ENTER OTP NO.{" "}
                <img src="/images/speaker.webp" alt="Speaker" width="30" />
              </label>
            </div>

            {/* 3. OK Button */}

            <div className="otp-step">
              <div
                className="element-with-speaker1"
                style={{ marginTop: "15px" }}
              >
                <button
                  className="verify-otp-btn"
                  onClick={verifyOtp}
                  disabled={!generatedOtp || otp.length === 0}
                >
                  <img src="/images/verify.jpg" alt="OK" width="100" />
                </button>
                <img
                  src="/images/speaker.webp"
                  className="m-2"
                  alt="Speaker"
                  width="20"
                />
              </div>
            </div>
          </div>
        )}
        {/* Submit Vote */}
        {otpVerified && (
          <div className="otp-step">
            <div className="element-with-speaker1" style={{ marginTop: "15px" }}>
              <button
                className="verify-otp-btn"
                onClick={handleVote}
                disabled={!generatedOtp || otp.length === 0}
              >
                <img src="/images/submit.jpg" alt="OK" width="180" />
              </button>
          
            </div>
          </div>
        )}
        {/* Submit Vote */}
      </div>
      {showSuccessPopup && (
        <div className="success-popup-overlay">
          <div className="success-popup">
            <div className="checkmark-container">
              <div className="checkmark"></div>
            </div>
            <h2>Vote Cast Successfully!</h2>
          </div>
        </div>
      )}
    </div>
  );
}

export default VotingPage;
